import { call, put, select, takeLatest } from 'redux-saga/effects'
import { BillingConstants } from '../../billing/store/billing.constants'
import { IPcr } from '../../pcr/store/pcr.types'
import { setAuthorizationInformationState } from '../store/authorizationInformation.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getPcrIdSelector } from '../../home/selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* getAuthorizationInformation(pcrDoc: IPcr) {
  const authorizationInformation = pcrDoc.billing?.authorizationInformation
  if (authorizationInformation && Object.keys(authorizationInformation).length !== 0) {
    yield put(setAuthorizationInformationState(authorizationInformation))
  }
}

export function* preloadPCR() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    yield call(getAuthorizationInformation, pcrDoc)
  } catch (e) {
    yield put(throwPcrException(`preloadPCR() error in getAuthorizationInformation.saga.ts: ${e}`))
  }
}

export function* getAuthorizationInformationSaga() {
  yield takeLatest([BillingConstants.REFRESH_BILLING_DATA], performWithMutexHOG, preloadPCR)
}
